import { TextField, Box, Typography, InputAdornment } from '@mui/material';
import React, { useState, FC } from 'react';
import { i18n } from '../../i18n/i18n';
import MuiDialogWrapper from '../../components/MuiDialogWrapper/MuiDialogWrapper';
import { COLORS } from '../../constants/constants';
import { IconXWindow } from '../../images';

interface CaseModalProps {
    close: any;
    data: any;
}

const CaseDialog: FC<CaseModalProps> = ({ close, data }) => {
    const [caseNameInput, setCaseNameInput] = useState(data.case ? data.case.name : '');
    const [caseDescriptionInput, setCaseDescriptionInput] = useState(data.case ? data.case.description : '');

    const onSave = () => {
        data.onSave(caseNameInput, caseDescriptionInput);
        close();
    };

    return (
        <MuiDialogWrapper
            styles={{ width: '720px' }}
            title={data.title}
            onClose={close}
            content={
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {data.parentCase && (
                        <Typography sx={{ fontSize: '16px', color: COLORS.MUTED_DARK, fontWeight: 500 }}>
                            {i18n.translate('Parent Case')}: {data.parentCase}
                        </Typography>
                    )}
                    <Typography sx={{ fontSize: '16px', color: COLORS.MUTED_DARK, fontWeight: 500 }}>
                        {data.isFirstCase
                            ? i18n.translate('Type a name for your first case folder and start collecting')
                            : i18n.translate('Type a name for your case folder and start collecting')}
                    </Typography>
                    <TextField
                        value={caseNameInput}
                        onChange={(e) => setCaseNameInput(e.target.value)}
                        label={i18n.translate('Case Name')}
                        sx={{ mt: 2 }}
                        InputProps={{
                            endAdornment: caseNameInput && (
                                <InputAdornment
                                    position="start"
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => setCaseNameInput('')}
                                >
                                    <IconXWindow className="fill-md" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label={i18n.translate('Enter Case description')}
                        multiline
                        value={caseDescriptionInput}
                        onChange={(e) => setCaseDescriptionInput(e.target.value)}
                        sx={{
                            'mt': 3,
                            '& .MuiInputLabel-root': {
                                display: 'flex',
                                alignItems: 'start',
                            },
                            '& .MuiOutlinedInput-root': {
                                height: '100%',
                            },
                        }}
                        rows={3}
                    />
                </Box>
            }
            buttons={[
                {
                    name: i18n.translate('Save'),
                    onClick: onSave,
                    disabled: !caseNameInput,
                    color: 'primary',
                },
            ]}
        />
    );
};

export default CaseDialog;
